import { HStack, VStack } from '@/components/sgBootstrapReactWrapper';
import type { JSX } from 'react';
import { FormattedMessage } from 'react-intl';
import { FormattedValue } from './FormattedValue';
import { type FieldSpec, getFieldName, type PositionType, type PositionTypeName } from './template';

interface Props {
  fieldSpec: FieldSpec;
  position: PositionType;
  header?: boolean;
  positionType: PositionTypeName,
}

export const Field = ({ fieldSpec, position, header = false, positionType }: Props) => {
  const fieldName = getFieldName(fieldSpec);

  const translatedFieldNameI18key = `operation.drawer.${fieldName}`
  const fieldNameElement = <FormattedMessage id={translatedFieldNameI18key} />

  const valueElement: JSX.Element = <FormattedValue fieldSpec={fieldSpec} position={position} />;

  return header ? (
    <VStack gap="4px" className="g-col-6 justify-content-lg-start">
      <div className="text-secondary">{fieldNameElement}</div>
      <div>
        {valueElement}
      </div>
    </VStack>
  ) : (
    <HStack padding="4px" className="justify-content-between border-bottom">
      <span className="fw-medium text-secondary">{fieldNameElement}</span>
      {valueElement}
    </HStack>
  );
};
